/* DON'T EDIT THIS FILE: edit original and run build again */ export const updateTenantCallName = "updateTenantCall";

export type UpdateTenantCall = {
  name: typeof updateTenantCallName;
  signature: (params: { tenant: string; loginAgain?: boolean }) => Promise<{
    loginToken: string | null;
  }>;
};
